export enum DDoSExecutionModeEnum {
  Logging,
  Blocking,
}
